import { baseRequest } from './Request'

export const get = baseRequest({ method: 'GET' })
export const post = baseRequest({ method: 'POST' })
export const deleteRequest = baseRequest({ method: 'DELETE' })
export const put = baseRequest({ method: 'PUT' })
